<template>
  <span class="base-pagination-trigger" @click="onClick">
    {{ pageNumber }}
  </span>
</template>

<script>
export default {
  props: {
    pageNumber: {
      type: Number,
      required: true
    }
  },

  methods: {
    onClick() {
      this.$emit("loadPage", this.pageNumber);
    }
  }
};
</script>

<style lang="scss" scoped>
$c-primary-accent--dark: #6a1b9a;
$c-primary-accent: #2a7996;

.base-pagination-trigger {
  cursor: pointer;
  transition: all 300ms ease;
  font-family: Roboto,sans-serif;
  font-weight: 400;
  font-size: 16px;
  &:hover {
    // color: $c-primary-accent;
    text-decoration: underline;
  }
}
</style>
